<form [formGroup]="form" autocomplete="off" (ngSubmit)="search()">
    <div class="row">
        <rask-input class="col-2" label="{{ 'PRODUKT_LIST_NAMN' | translate }}" formControlName="produktnamn" [rule]="" aid="inputProduktnamn">
        </rask-input>

        <rask-input class="col-2" label="{{ 'PRODUKT_LIST_PRODUKTGRUPP' | translate }}" formControlName="produktgrupp"
            [rule]="" aid="inputProduktgrupp">
        </rask-input>

        <rask-input class="col-2" label="{{ 'PRODUKT_LIST_HANDELSSORTIMENT' | translate }}"
            formControlName="handelssortiment" [rule]="" aid="inputHandelssortiment">
        </rask-input>

        <rask-input class="col-2" label="{{ 'PRODUKT_LIST_SORTIMENTSKOD' | translate }}" formControlName="sortimentskod"
            [rule]="" aid="inputSortiment">
        </rask-input>

        <rask-input class="col-2" label="{{ 'PRODUKT_LIST_TRADSLAG' | translate }}" formControlName="tradslag"
            [rule]="" aid="inputTradslag">
        </rask-input>

        <rask-input class="col-2" label="{{ 'PRODUKT_LIST_BETECKNING' | translate }}" formControlName="beteckning"
            [rule]="" aid="inputBeteckning">
        </rask-input>
    </div>
    <div class="row">
        <div class="col">
            <rask-radiobutton-group label="{{ 'PRODUKT_LIST_AKTIV' | translate }}" [buttons]="activetypes"
                formControlName="aktiv" [rule]="" aid="aktivRadio">
            </rask-radiobutton-group>
            <rask-submit-button color="secondary" aid="produktSok">{{ 'DEFAULT_BUTTON_LABEL_SOK' | translate }}</rask-submit-button>
        </div>
    </div>
</form>
